//======> Docementation <======//
registerBlockType("tornado/eeroo", {
  title: __("Slider video", "tornado"),
  description: __("بلوك", "tornado"),
  icon: "feedback",
  category: "tornado",
  keywords: ["tornado", "section"],
  supports: {
    align: ["full", "wide"],
  },
  attributes: {
    media_video: {
      type: "string",
      selector: ".video",
      default: "https://www.w3schools.com/html/mov_bbb.mp4",
    },
    media : {
      type: 'string',
      default: 'video',
  },
},
  edit({attributes,setAttributes , className}){
    const {  media_video} = attributes;
    const set_media_video = (openEvent) => {
      return (
        <div className="video-uploader">
          <video
            src={media_video}
            className="round-corner video"
            type="video/mp4"
            controls
          ></video>
          <a
            href="javascript:void(0);"
            onClick={openEvent}
            className="btn"
          >
            تغيير الفيديو
          </a>
        </div>
      );
    };   
    
    return (
      <Panel>
        <InspectorControls style={{ marginBottom: "40px" }}>
          <PanelBody>
            <p> تغيير الفيديو </p>
              <MediaUpload
                render={({ open }) => set_media_video(open)}
                value={media_video}
                onSelect={(media) => {
                  setAttributes({ media_video: media.url });
                }}
              />
          </PanelBody>
        </InspectorControls>
      
      <div className="hero-intro responsive-element tx-align-center">
          <video src= {attributes.media_video} autoplay muted loop></video>
      </div>
      
</Panel>
    );
  },
  save({attributes , className}){
    const {  media_video} = attributes;
    return (
      // <!-- Hero Intro -->
      <div className="hero-intro responsive-element tx-align-center">
          <video src={attributes.media_video} autoplay muted loop></video>
      </div>
      // <!-- // Hero Intro -->

    );
  }
});